import { transparentize } from "polished";
import styled from "styled-components";
import { HowRewardsWork } from "../how-rewards-work";
import { MobileQRCode } from "../mobile-qr-code";
import { PointsHistory } from "../points-history";
import { RedeemReceipt } from "../redeem-receipt/redeem-receipt";
import { COMPONENT_CONFIG } from "@/brand-components";
import LoyaltyAccessor from "@/components/account/loyaltyAccessor";
import { LOYALTY_ACCESSOR_TYPES, LOYALTY_FEATURES } from "@/constants/loyalty";
import { useSelector } from "@/redux";
import { safePolished } from "@/utils/safePolished";

export function RewardsFooter() {
  const { slug } = useSelector((state) => state.app.organization.organization);
  const { webConfig, strings } = useSelector((state) => state.app.cmsConfig);
  const howRewardsWorkExternalURL = strings.rewards.learn_more_url;
  const REWARDS_TERMS_CONTENT = COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK[slug];

  return (
    <>
      <Container>
        <Content>
          {/* Only show Rewards Terms if component exists or if an external rewards information URL is present */}
          {(howRewardsWorkExternalURL || REWARDS_TERMS_CONTENT) && (
            <HowRewardsWork externalURL={howRewardsWorkExternalURL} />
          )}
          <LoyaltyAccessor
            checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
            checkName={LOYALTY_FEATURES.SHOW_LOYALTY_HISTORY}
            component={<PointsHistory />}
          />
          {webConfig.accounts.barcode_scan && (
            <LoyaltyAccessor
              checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
              checkName={LOYALTY_FEATURES.CLAIM_REWARDS_BY_RECEIPT}
              component={<RedeemReceipt />}
            />
          )}
        </Content>
      </Container>
      {/* Mobile-Only User QR Code Button */}
      <LoyaltyAccessor
        checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
        checkName={LOYALTY_FEATURES.SUPPORTS_QR}
        component={<MobileQRCode />}
      />
    </>
  );
}

const Container = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    safePolished(transparentize)("0.9", theme.global.primary_active_color)};

  justify-content: center;
  min-width: 100%;
  padding: var(--size-5) var(--size-5) var(--size-32); // Large bottom padding account for mobile QR code
  width: 100%;

  h1 {
    font-family: ${({ theme }) => theme.primary_font.bold.font_family};
    font-size: 24px;
    text-align: left;
  }

  button {
    align-items: center;
    max-width: 75%;

    @media (max-width: 1024px) {
      min-width: 100% !important;
    }
  }

  @media (min-width: 768px) {
    padding: var(--size-16) var(--size-5);
  }
`;

const Content = styled.div`
  display: grid;
  gap: var(--size-12);
  grid-template-columns: 1fr;
  margin: 0 auto;
  max-width: var(--size-4xl);
  width: 100%;

  @media (min-width: 768px) {
    gap: var(--size-5);
    grid-template-columns: repeat(3, 1fr);
  }
`;
